import React from "react"
import { SearchParameters } from "../../../../../features/algolia/api/types/search"
import { useAlgoliaSearchState } from "../../controller/state"
import { AlgoliaCheckboxOption } from "../../controller/state/types"
import { SwitchFilterChip } from "../SwitchFilterChip"
import classes from "./SwitchFilters.module.css"

const isHidden = (
  item: AlgoliaCheckboxOption,
  hiddenFilters?: SearchParameters
) =>
  hiddenFilters?.tags?.some(
    (x) => x.key.toLowerCase() === item.key.toLowerCase()
  )

const SwitchFilters = () => {
  const { uiFilters, hiddenFilters } = useAlgoliaSearchState()
  return (
    <div className={classes.chipsContainer}>
      <div className={classes.chipsRow}>
        {uiFilters?.chips
          ?.filter((x) => !x.disabled && !isHidden(x, hiddenFilters))
          .map((item) => (
            <SwitchFilterChip item={item} key={item.value} />
          ))}
      </div>
    </div>
  )
}

export default SwitchFilters
